import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { EditHookReturnType } from '../../types';
import { ApiKeyTemplateRegistrationInputModalView } from './ApiKeyTemplateRegistrationInputModalView';
import { ApiKeyTemplateRegistrationConfirmModalView } from './ApiKeyTemplateRegistrationConfirmModalView';
import { ApiKeyTemplateRegistrationResultModalView } from './ApiKeyTemplateRegistrationResultModalView';

type Props = EditHookReturnType;

export const ApiKeyTemplateRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  mode,
  clawlers,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <ApiKeyTemplateRegistrationInputModalView
        mode={mode}
        {...form}
        handleConfirm={onConfirm}
        onOpenModalDelete={onOpenModalDelete}
        clawlers={clawlers}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <ApiKeyTemplateRegistrationConfirmModalView
        mode={mode}
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <ApiKeyTemplateRegistrationResultModalView
        mode={mode}
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
